/*
  Шрифти самохостяться: без стороннього домену й без стрибка верстки, коли
  шрифт догружається. Раніше --font-sans називав Inter, але жодного @font-face
  не було — працював системний шрифт.
*/
import '@fontsource-variable/geist';
import '@fontsource-variable/geist-mono';
import '@fontsource-variable/unbounded';
import './styles.css';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './app';

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Root element #root not found');

createRoot(rootElement).render(
	<StrictMode>
		<App />
	</StrictMode>,
);
